<template>
  <div id="total_import">
    <h3>批量导入</h3>
    <div class="import_box">
      <a-steps :current="current">
        <a-step v-for="item in steps" :key="item.title" :title="item.title" />
      </a-steps>
      <div class="steps-content">
        <div v-if="current === 0" class="import_flex step_contnet">
          <div>
            <div class="down_con">
              <a :href="'https://www.lvluoxinli.com/static/students_info_model.xls'" download><a-icon type="download"/>下载批量导入学生模板</a>
            </div>
            <a-upload-dragger
              name="file"
              :multiple="true"
              :action="URL.upload"
              @change="fileChange"
              :beforeUpload="beforeUpload"
              :max-count="1"
              accept=".xls,.xlsx, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            >
              <p class="ant-upload-drag-icon">
                <img src="@/assets/upload_icon.png" alt="">
              </p>
              <p class="ant-upload-text">点击或将文件拖拽到这里上传</p>
              <p class="ant-upload-hint">支持扩展名：xls</p>
            </a-upload-dragger>
          </div>
        </div>
        <div v-if="current === 1" class="import_flex step_contnet">
          <div v-if="uploadInfo && uploadTotal" class="step_two_box">
            <div class="num_title num_total import_flex">
              <span>学生数量：</span>
              <span>{{uploadInfo.length}}</span>
            </div>
            <div class="num_title num_grade import_flex">
              <span>包含年级：</span>
              <div><span v-for="(item, index) in uploadTotal.newGrade" :key="index + 'lk'" style="margin-right: 10px;">{{item ? item : '未知年级'}}</span></div>
            </div>
            <div v-for="(item, index) in uploadTotal.newGrade" :key="index + 'a'" class="num_title num_class import_flex">
              <span>{{`${item ? item : '未知年级'}：`}}</span>
              <span>{{uploadTotal.classTotal[index].join('、')}}</span>
            </div>
          </div>
        </div>
        <div v-if="current === 2" class="import_flex step_contnet">
          <div v-if="uploadResult">
            <div class="result_icon import_flex">
              <div>
                <div style="text-align: center">
                  <img src="@/assets/complete_icon.png" alt="">
                </div>
                <div class="result_num">
                  <span>{{`成功导入${uploadResult.goodTotal ? uploadResult.goodTotal.length : 0}人`}}</span>
                  <span>{{`${uploadResult.errorList.length}人导入失败`}}</span>
                </div>
              </div>
            </div>
            <div class="result_info">
              <img src="@/assets/prompt_icon.png" alt="">
              <div class="mess_box">
                <span>温馨提示</span>
                <span>{{`本次有${uploadResult.errorList.length}人导入失败，已保存在【待修正学生信息】。`}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="steps-action">
        <a-button v-if="current === 0" type="primary" @click="next" :disabled="nextDisable">下一步</a-button>
        <a-button v-if="current === 1" @click="prev" style="margin-right: 12px">上一步</a-button>
        <a-button v-if="current === 1" type="primary" @click="submitHandle" :disabled="submitDisable">提交</a-button>
        <a-button v-if="current === 2" type="primary" @click="amendHandle" style="margin-right: 12px">修正学生信息</a-button>
        <a-button v-if="current === 2" @click="backHandle">返回</a-button>
        <div v-if="flagMark" class="red_mark mark_red">检测到表格中的年级超出学校设置的年级范围</div>
        <div v-if="flagMark" class="red_mark">建议<span @click="upateGradeHandle">更改学校年级设置</span></div>
      </div>
    </div>
  </div>
</template>

<script>
import XLSX from 'xlsx'
import { mapState, mapActions, mapMutations } from 'vuex'
import STUDENTFUN from '@/util/studentFun'
import axios from 'axios'
import URL from '@/store/url'
export default {
  name: 'TotalImport',
  data () {
    return {
      current: 0,
      steps: [
        {
          title: '上传表格'
        },
        {
          title: '确认学生信息'
        },
        {
          title: '完成'
        }
      ],
      uploadInfo: null,
      uploadTotal: null,
      uploadResult: null,
      nextDisable: true,
      xslFlag: null,
      currentTwoText: [],
      fileList: [],
      editGradeList: null,
      submitDisable: false,
      flagMark: false,
      URL: {upload: 'https://api.lvluoxinli.com/api/odata/teacher/file'},
      worker: null
    }
  },
  computed: {
    ...mapState([
      'userInfo',
      'teacherAdmin',
      'schoolGrades',
      'errorPostFlag', // 批量导入弹窗消失的一个条件
      'uploadFlag' // 批量导入弹窗消失的一个条件
    ])
  },
  // async mounted () {
  //   await this.getErrorStu()
  // },
  watch: {
    schoolGrades () {
      this.togetherJudge()
    }
  },
  methods: {
    ...mapActions([
      'getPostErrorInfo',
      // 'getErrorStu',
      // 'getAddStuInfo',
      'getSchoolInfos',
      'uploadStu',
      'uploadAll',
      'logAdd'
    ]),
    ...mapMutations([
      'setEditUpdateGrade',
      'setSelectKey',
      'setTotalSpinning',
      'setUploadCancel',
      'setImportPro'
    ]),
    togetherJudge () {
      let compareList = []
      let compareState = []
      let compareClassState = []
      console.log(this.uploadInfo)
      this.uploadTotal = STUDENTFUN.uploadData(this.uploadInfo) // 转换上传的excle表格
      console.log(this.uploadTotal)
      if (this.schoolGrades) {
        this.editGradeList = STUDENTFUN.editGradeReplace(this.schoolGrades)
        this.editGradeList.map(item => {
          compareList.push(item.val)
        })
        this.uploadTotal.newGrade.map((item, index) => { // 判断上传的学生是否超出年级范围
          if (item && compareList.includes(item)) {
            compareState.push(true)
          } else {
            if (!item) {
              compareState.push(null)
            } else {
              compareState.push(false)
            }
          }
          console.log(this.uploadTotal.classTotal[index].filter(key => parseInt(key) > 100))
          if (this.uploadTotal.classTotal[index].includes('未知班') || this.uploadTotal.classTotal[index].filter(key => parseInt(key) > 100).length) {
            console.log('wei')
            compareClassState.push(false)
          } else {
            compareClassState.push(true)
          }
        })
        if (compareState.includes(null)) {
          this.submitDisable = true
          if (compareClassState.includes(false)) {
            this.$message.error(`检测到未知年级或班级，请修改上传的表格`)
          } else {
            this.$message.error(`检测到未知年级，请修改上传的表格`)
          }
          console.log(this.submitDisable)
        } else {
          if (compareState.includes(false)) {
            this.submitDisable = true
            this.flagMark = true
          } else {
            if (compareClassState.includes(false)) {
              this.submitDisable = true
              this.$message.error(`检测到未知班级，请修改上传的表格`)
            } else {
              this.submitDisable = false
            }
            this.flagMark = false
          }
        }
        console.log(compareState)
        console.log(compareClassState)
        // if (compareClassState.includes(false)) {
        //   this.submitDisable = true
        // } else {
        //   this.submitDisable = false
        // }
      }
    },
    next () {
      this.current++
      this.togetherJudge()
    },
    prev () {
      this.current--
      this.flagMark = false
      this.nextDisable = true
    },
    async proFun (stuList) {
      let newList = []
      for (const item of stuList) {
        console.log(item)
        item.SCHOOL_ID = this.userInfo.school_id
        item.UID = this.teacherAdmin.uid
        item.ROLE_ID = this.userInfo.role_id
        newList.push(new Promise((resolve,reject) => {
          axios.post(URL.ADD_STUDENT, item).then(res=>resolve(res)).catch(err=>reject(err))
        }))
      }
      return newList
    },
    async submitHandle () {
      this.setTotalSpinning(true)
      this.uploadResult = STUDENTFUN.testInfo(this.uploadInfo)
      let errFlag = []
      const errArr = ['CLASS_ID', 'GRADE_ID', 'REAL_NAME', 'SCHOOL_ID', 'SEX', 'STATUS', 'STUDENT_ID_CARD', 'STUDENT_ID_SOCIAL']
      if (this.uploadResult) {
        console.log(this.uploadResult)
        if (this.uploadResult.goodTotal) {
          const stuList = STUDENTFUN.addStuReplace(this.uploadResult.goodTotal, this.userInfo.school_id)
          // try {
          //   await this.uploadAll({
          //     UID: this.teacherAdmin.uid,
          //     SCHOOL_ID: this.userInfo.school_id,
          //     ROLE_ID: this.userInfo.role_id,
          //     data: stuList
          //   })
          // } catch(e) {
          //   console.log(e)
          //   this.setTotalSpinning(false)
          //   this.$message.error(`导入学生失败`)
          //   this.$router.push('/studentList/studentInfo')
          // }
        //   this.worker = this.$worker.run(() => {}, []).then(res => {
        //     console.log(res)
        //     for (const item of stuList) {
        //       item.SCHOOL_ID = this.userInfo.school_id
        // item.UID = this.teacherAdmin.uid
        // item.ROLE_ID = this.userInfo.role_id
        //       axios.post(URL.ADD_STUDENT, item).then(res=> {
        //         console.log(res)
        //       })
        //     }
        //   }).catch(e => console.log(e))
          // 试用
          // const promise = await this.proFun(stuList)
          // console.log(promise)
          // const result  = await Promise.all(promise)
          // console.log(result)
          // 原
          let num = 0
          for (const item of stuList) {
            try {
              let response = await this.uploadStu(item)
              if (!response.data.success) {
                this.setTotalSpinning(false)
                this.$message.error(`导入学生失败`)
                this.$router.push('/studentList/studentInfo')
                break
              }
              num++
            } catch(e) {
              console.log(e)
              this.setTotalSpinning(false)
              this.$message.error(`导入学生失败`)
              this.$router.push('/studentList/studentInfo')
              break
            }
            this.setImportPro(((num/stuList.length) * 100).toFixed(2))
          }
        } else {
          if (this.uploadResult.errorList.length !== 0) {
            console.log(this.uploadResult.errorList)
            let errorInfos = STUDENTFUN.errorSubmitInfo(this.uploadResult.errorList)
            errorInfos.map(item => {
              delete item.ENTRYYEAR
              Object.keys(item).forEach(val => {
                if (!errArr.includes(val)) {
                  errFlag.push(false)
                }
              }) 
            })
            console.log(errorInfos)
            console.log(errFlag)
            if (!errFlag.length) {
              try {
                await this.getPostErrorInfo(errorInfos)
              } catch (e) {
                console.log(e)
                this.setTotalSpinning(false)
                this.$message.error(`导入学生失败`)
                this.$router.push('/studentList/studentInfo')
              }
            } else {
              this.$message.error(`导入待修正学生失败`)
            }
          }
        }
        if (this.uploadFlag) {
          if (this.uploadResult.errorList.length !== 0) {
            let errorInfos = STUDENTFUN.errorSubmitInfo(this.uploadResult.errorList)
            errorInfos.map(item => {
              Object.keys(item).forEach(val => {
                if (!errArr.includes(val)) {
                  errFlag.push(false)
                }
              }) 
            })
            console.log(errFlag)
            if (!errFlag.length) {
              try {
                await this.getPostErrorInfo(errorInfos)
              } catch (e) {
                this.setTotalSpinning(false)
                this.$message.error(`导入学生失败`)
                this.$router.push('/studentList/studentInfo')
              }
            } else {
              this.$message.error(`导入待修正学生失败`)
            }
          }
        }
        if (this.uploadResult.goodTotal && this.uploadResult.errorList.length !== 0) {
          if (this.uploadFlag && this.errorPostFlag === 'Created') {
            this.setTotalSpinning(false)
            this.current++
          }
        }
        if (!this.uploadResult.goodTotal && this.uploadResult.errorList.length !== 0) {
          if (this.errorPostFlag === 'Created') {
            this.setTotalSpinning(false)
            this.current++
          }
        }
        if (this.uploadResult.goodTotal && this.uploadResult.errorList.length === 0) {
          if (this.uploadFlag) {
            this.setTotalSpinning(false)
            this.current++
          }
        }
        await this.logAdd({
          name: '学生-学生列表-批量导入学生',
          remarks: `成功导入${this.uploadResult.goodTotal.length}人`	
        })
      }
    },
    readExcel(file) {// 解析Excel
      return new Promise((resolve, reject) => { // 返回Promise对象
        const reader = new FileReader()
        reader.onload = (e) => { // 异步执行
          try {
            // 以二进制流方式读取得到整份excel表格对象
            let dataOne = e.target.result, workbook = XLSX.read(dataOne, {type: 'binary'})
            let sheetName = workbook.SheetNames[0]
            console.log(sheetName)
            let studentInfo = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName])
            let objArr = Object.values(studentInfo[1])
            if (objArr.join('') === '姓名性别年级班级身份证号码' || objArr.join('') === '姓名性别年级班级学籍号') {
              this.xslFlag = true
              this.uploadInfo = STUDENTFUN.replaceKey(studentInfo, this.teacherAdmin)
              console.log(this.uploadInfo)
            } else {
              this.xslFlag = false
              this.$message.info(`上传的表格与下载的模板不符，请核对`)
            }
          } catch (e) {
            reject(e.message)
          }
        }
        reader.readAsBinaryString(file)
      })
    },
    fileChange(info) {
      console.log(info.file.size)
      const status = info.file.status
      if (status !== 'uploading') {
        console.log(info.file, info.fileList)
      }
      if (info.fileList.length === 0) {
        this.nextDisable = true
      }
      if (status === 'done') {
        if (this.xslFlag) {
          this.nextDisable = false
          this.$message.success(`上传表格成功`)
        }
      } else if (status === 'error') {
        this.nextDisable = true
        this.$message.error(`上传表格失败`)
      }
    },
    Err (message) {
      this.$message.error(message)
    },
    beforeUpload (file, fileList) {
      // 使返回的值变成Promise对象，如果校验不通过，则reject，校验通过，则resolve
      const types = ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.ms-excel']
      new Promise((resolve, reject) => {
        // 文件后缀名校验
        if (file.type && !types.includes(file.type)) {
          this.Err('只允许上传 .xls,.xlsx 后缀的文件')
          return reject(false)
        }
        if (fileList.length > 1) {
          this.Err('只允许上传单个 Excel 文件')
          return reject(false)
        }
        const isLt = file.size / (1024 * 1024) <= 1//图片大小不超过2MB
        if(!isLt) {
          this.$message.error(`上传的表格过大，请重新操作或联系工作人员`)
          return reject(false)
        } else {
          // readExcel方法也使用了Promise异步转同步，此处使用then对返回值进行处理
          this.readExcel(file).then(result => { // 此时标识校验成功，为resolve返回
            if (result) resolve(result)
          })
        }
      })
    },
    upateGradeHandle () {
      this.setEditUpdateGrade(true)
    },
    amendHandle () {
      this.setSelectKey('2')
      this.$router.push('/studentList/amendInfo')
    },
    async backHandle () {
      // await this.getSchoolInfos()
      this.$router.push('/studentList/studentInfo')
    }
  },
  destroyed () {
    this.worker = null
  }
}
</script>

<style>
#total_import {
  width: 100%;
  padding: 32px 0px 50px 24px;
  box-sizing: border-box;
}
#total_import .import_flex {
  display: flex;
  align-items: center;
}
#total_import h3 {
  font-size: 24px;
  font-weight: 500;
  color: #262626;
  margin-bottom: 24px;
}
#total_import .import_box {
  width: 100%;
  padding: 40px 104px 24px;
  background-color: #FFFFFF;
  border: 1px solid #E8E8E8;
  box-sizing: border-box;
}
#total_import .steps-content {
  padding-top: 40px;
  box-sizing: border-box;
}
#total_import .ant-btn-link, #total_import .ant-btn-link:focus {
  color: #262626; 
}
#total_import .ant-btn-link:hover, #total_import .down_con a:hover {
  color: #1890FF;
}
#total_import .ant-upload.ant-upload-drag {
  width: 350px;
  padding: 50px 0px 20px;
  margin-top: 20px;
}
#total_import .step_contnet {
  justify-content: center;
  margin-bottom: 40px;
}
#total_import .steps-action {
  text-align: center;
}
#total_import .num_title {
  color: #262626;
}
#total_import .num_title > span:first-child {
  flex-basis: 25%;
  text-align: right;
}
#total_import .num_title > span:last-child {
  flex-basis: 75%;
  margin-left: 8px;
}
#total_import .num_total {
  margin-bottom: 32px;
}
#total_import .num_total > span:last-child {
  font-size: 24px;
}
#total_import .num_grade {
  margin-bottom: 24px;
}
#total_import .num_class {
  margin-bottom: 16px;
}
#total_import .num_title:last-child {
  margin-bottom: 0px;
}
#total_import .result_icon {
  margin: 32px 0px 80px;
  justify-content: center;
}
#total_import .result_num {
  margin-top: 24px;
}
#total_import .result_num span {
  display: block;
  text-align: center;
}
#total_import .result_num span:first-child, #total_import .result_info .mess_box span:first-child {
  font-size: 16px;
  color: #262626;
  font-weight: bold;
}
#total_import .result_num span:last-child {
  font-size: 12px;
  color: #BFBFBF;
}
#total_import .result_info {
  width: 500px;
  padding: 16px 24px;
  border-radius:4px;
  display: flex;
  box-sizing: border-box;
  background-color: #E6F7FF;
  border:1px solid #BADEFF;
  align-items: flex-start;
}
#total_import .result_info .mess_box {
  margin-left: 12px;
}
#total_import .result_info .mess_box span {
  display: block;
}
#total_import .result_info .mess_box span:last-child {
  margin-top: 6px;
  color: #595959;
}
#total_import .step_two_box {
  width: 600px;
}
#total_import .red_mark {
  color: #F5222D;
}
#total_import .red_mark span {
  color: #1890FF;
  cursor: pointer;
  border-bottom: 1px solid #1890FF;
}
#total_import .mark_red {
  margin-top: 16px;
}
#total_import .down_con a {
  color: #262626;
}
#total_import .down_con a:link {
  text-decoration: none;
}
#total_import .ant-steps-item-process .ant-steps-item-icon, #total_import .ant-btn-primary {
  background-color: #51BF94;
  border-color: #51BF94;
  color: #FFFFFF;
}
#total_import .ant-btn-primary:hover {
  color: #FFFFFF;
  background-color: rgba(81, 191, 148, .6);
  border-color: rgba(81, 191, 148, .6);
}
#total_import .ant-steps-item-finish .ant-steps-item-icon {
  border-color: #51BF94;
}
#total_import .ant-steps-item-finish .ant-steps-item-icon > .ant-steps-icon {
  color: #51BF94;
}
#total_import .ant-steps-item-finish > .ant-steps-item-content > .ant-steps-item-title::after {
  background-color: #51BF94;
}
</style>
